import React, { useState } from 'react';

const TeamSetup = ({ onStart }) => {
  const [numTeams, setNumTeams] = useState(2);
  const [teamNames, setTeamNames] = useState(['', '']);

  const handleNumTeamsChange = (e) => {
    const count = parseInt(e.target.value);
    setNumTeams(count);
    setTeamNames(Array(count).fill(''));
  };

  const handleNameChange = (index, name) => {
    const newNames = [...teamNames];
    newNames[index] = name;
    setTeamNames(newNames);
  };

  const handleStart = () => {
    if (teamNames.every(name => name.trim() !== '')) {
      onStart(teamNames);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2">اختر عدد الفرق</h2>
      <select value={numTeams} onChange={handleNumTeamsChange}>
        {[2, 3, 4].map(n => (
          <option key={n} value={n}>{n} فرق</option>
        ))}
      </select>

      <div className="mt-4">
        {teamNames.map((name, i) => (
          <div key={i}>
            <label>اسم الفريق {i + 1}:</label>
            <input
              type="text"
              value={name}
              onChange={(e) => handleNameChange(i, e.target.value)}
              className="border p-1 m-1"
            />
          </div>
        ))}
      </div>

      <button onClick={handleStart} className="mt-4 bg-blue-500 text-white px-4 py-2 rounded">
        ابدأ اللعبة
      </button>
    </div>
  );
};

export default TeamSetup;
